import React, {useEffect, useState} from 'react';
import FullWidthRow from "../layout/components/FullWidthRow"
import Container from "../layout/components/Container"
import {Paper} from "material-ui"
import GroupTaskList from "../admin/group-task-list/GroupTaskList"
import CompletedTasks from '../admin/competed-tasks/CompletedTasks';
import Counsellors from 'modules/admin/counsellors/Counsellors';
import BadFit from 'modules/admin/bad-fit/BadFit';
import { fetchBadFitItems, fetchCounsellors } from 'modules/admin/redux/actions';
import { useDispatch } from 'react-redux';
import Loading from 'ui-components/Loading';

const AdminHomepage = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    
    useEffect(async () => {
        await dispatch(fetchCounsellors())
        await dispatch(fetchBadFitItems())
        setLoading(false)
    }, [dispatch])

    return (
       <FullWidthRow>
           <Container>
                <Paper elevation={4} className="admin-homepage">
                    {
                        loading ? 
                        <Loading/>
                        : 
                        <>
                            <GroupTaskList/>
                            <CompletedTasks/>
                            <BadFit/>
                            <Counsellors/>
                        </>
                    }
                    
            </Paper>
           </Container>
       </FullWidthRow>
    );
};

export default AdminHomepage;